import { Typography } from "@mui/material";
import React from "react";

const StepCaption = ({ text, containerStyles }) => {
  return (
    <Typography
      color="secondary"
      sx={{
        fontFamily: "FSElliotPro",
        fontSize: "20px",
        fontWeight: "700",
        lineHeight: 1.4,
        margin: "12px 16px 24px",
        textAlign: "left",
        ...(containerStyles || {}),
      }}
    >
      {text}
    </Typography>
  );
};

export default StepCaption;
